const LenderActionTypes = {
  /*****************  GET LENDER LIST START  *******************/
  GET_LENDER_LIST_START: "get_lender_list_start",
  GET_LENDER_LIST_SUCCESS: "get_lender_list_success",
  GET_LENDER_LIST_FAILURE: "get_lender_list_failure",
  GET_LENDER_LIST_RESPONSE_RESET: "get_lender_list_response_reset",
  GET_LENDER_LIST_RESPONSE_CHANGED: "get_lender_list_response_changed",
  /*****************  GET LENDER LIST END  *******************/

  /*****************  ADD LENDER DETAILS START  *******************/
  ADD_LENDER_DETAILS_START: "add_lender_details_start",
  ADD_LENDER_DETAILS_SUCCESS: "add_lender_details_success",
  ADD_LENDER_DETAILS_FAILURE: "add_lender_details_failure",
  ADD_LENDER_DETAILS_RESPONSE_RESET: "add_lender_details_response_reset",
  ADD_LENDER_DETAILS_RESPONSE_CHANGED: "add_lender_details_response_changed",
  /*****************  ADD LENDER DETAILS END  *******************/

  /*****************  UPDATE LENDER DETAILS START  *******************/
  UPDATE_LENDER_DETAILS_START: "update_lender_details_start",
  UPDATE_LENDER_DETAILS_SUCCESS: "update_lender_details_success",
  UPDATE_LENDER_DETAILS_FAILURE: "update_lender_details_failure",
  UPDATE_LENDER_DETAILS_RESPONSE_RESET: "update_lender_details_response_reset",
  UPDATE_LENDER_DETAILS_RESPONSE_CHANGED:
    "update_lender_details_response_changed",
  /*****************  UPDATE LENDER DETAILS END  *******************/

  /*****************  DELETE LENDER DETAILS START  *******************/
  DELETE_LENDER_DETAILS_START: "delete_lender_details_start",
  DELETE_LENDER_DETAILS_SUCCESS: "delete_lender_details_success",
  DELETE_LENDER_DETAILS_FAILURE: "delete_lender_details_failure",
  DELETE_LENDER_DETAILS_RESPONSE_RESET: "delete_lender_details_response_reset",
  DELETE_LENDER_DETAILS_RESPONSE_CHANGED:
    "delete_lender_details_response_changed",
  /*****************  DELETE LENDER DETAILS END  *******************/

  /*****************  FETCH LENDER DETAILS START  *******************/
  FETCH_LENDER_DETAILS_START: "fetch_lender_details_start",
  FETCH_LENDER_DETAILS_SUCCESS: "fetch_lender_details_success",
  FETCH_LENDER_DETAILS_FAILURE: "fetch_lender_details_failure",
  FETCH_LENDER_DETAILS_RESPONSE_RESET: "fetch_lender_details_response_reset",
  FETCH_LENDER_DETAILS_RESPONSE_CHANGED:
    "fetch_lender_details_response_changed",
  /*****************  FETCH LENDER DETAILS END  *******************/
  /*****************  FETCH LIST  LENDER DETAILS START  *******************/
  LENDER_LIST_FETCH_START: "lender_list_fetch_start",
  LENDER_LIST_FETCH_SUCCESS: "lender_list_fetch_success",
  LENDER_LIST_FETCH_FAILURE: "lender_list_fetch_failure",
  LENDER_LIST_RESPONSE_RESET_START: "lender_list_response_reset_start",
  LENDER_LIST_FETCH_RESPONSE_CHANGED: "lender_list_fetch_response_changed",
  /*****************  FETCH  LIST LENDER DETAILS END  *******************/
};
export default LenderActionTypes;
